import { Link } from "react-router-dom";
import { ShieldX, FileQuestion } from "lucide-react";
import { Button } from "@/components/ui/button";

function ErrorShell({ code, title, message, testid }) {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center text-center p-8" data-testid={testid}>
      <div className="rounded-2xl border bg-card p-10 shadow-sm max-w-md">
        <p className="font-heading text-5xl font-extrabold text-[#3A75C4]">{code}</p>
        <h1 className="mt-3 text-xl font-heading font-bold">{title}</h1>
        <p className="mt-2 text-sm text-muted-foreground">{message}</p>
        <Button asChild className="mt-6 bg-[#009E60] hover:bg-[#00804e] text-white" data-testid={`${testid}-home`}>
          <Link to="/">Retour au tableau de bord</Link>
        </Button>
      </div>
    </div>
  );
}

export function Forbidden() {
  return (
    <ErrorShell code="403" testid="error-403" title="Acces refuse"
      message="Vous ne disposez pas des permissions necessaires pour consulter cette page. Contactez un administrateur si vous pensez qu'il s'agit d'une erreur." />
  );
}

export function NotFound() {
  return (
    <ErrorShell code="404" testid="error-404" title="Page introuvable"
      message="La page demandee n'existe pas ou a ete deplacee." />
  );
}
